import { Link } from 'react-router-dom';
import { ENGAGEMENTS } from '@/lib/engagements';

export default function EngagementLinks({ current }: { current: string }) {
  return (
    <nav aria-label="Services" className="border-b border-rule bg-cream-light">
      <ul className="container grid grid-cols-2 gap-x-5 py-3 md:flex md:flex-wrap md:gap-x-8">
        {ENGAGEMENTS.map((offer) => (
          <li key={offer.to}>
            <Link to={offer.to} aria-current={current === offer.to ? 'page' : undefined} className={`inline-block py-3 text-small underline-offset-[0.3em] hover:underline ${current === offer.to ? 'underline' : ''}`}>{offer.label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
